export default "<h3>September 1, 2018</h3>\r\n<p>Update 0.22 fixes some bugs.</p>";